import { render, staticRenderFns } from "./addvehicleInfo.vue?vue&type=template&id=f3a42808"
import script from "./addvehicleInfo.vue?vue&type=script&lang=js"
export * from "./addvehicleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports